import React from 'react';
import { ChevronLeft, Star } from 'lucide-react';
interface HobbyType {
  id: string;
  name: string;
  icon: string;
  unlocksPosts: boolean;
}
interface Step5HobbyProps {
  selectedHobby: string;
  onSelect: (hobby: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const Step5Hobby: React.FC<Step5HobbyProps> = ({
  selectedHobby,
  onSelect,
  onNext,
  onBack
}) => {
  const hobbies: HobbyType[] = [{
    id: 'cosplay',
    name: 'Cosplay',
    icon: '👗',
    unlocksPosts: true
  }, {
    id: 'netflix',
    name: 'Watching Netflix',
    icon: '📺',
    unlocksPosts: false
  }, {
    id: 'gaming',
    name: 'Gaming',
    icon: '🎮',
    unlocksPosts: true
  }, {
    id: 'hiking',
    name: 'Hiking',
    icon: '🥾',
    unlocksPosts: false
  }, {
    id: 'cars',
    name: 'Cars',
    icon: '🏎️',
    unlocksPosts: false
  }, {
    id: 'parties',
    name: 'Parties',
    icon: '🎉',
    unlocksPosts: true
  }, {
    id: 'martial_arts',
    name: 'Martial Arts',
    icon: '🥋',
    unlocksPosts: false
  }, {
    id: 'photography',
    name: 'Photography',
    icon: '📷',
    unlocksPosts: true
  }, {
    id: 'vlogging',
    name: 'Vlogging',
    icon: '📱',
    unlocksPosts: true
  }, {
    id: 'cooking',
    name: 'Cooking',
    icon: '👩‍🍳',
    unlocksPosts: false
  }, {
    id: 'music',
    name: 'Music',
    icon: '🎵',
    unlocksPosts: false
  }, {
    id: 'dancing',
    name: 'Dancing',
    icon: '💃',
    unlocksPosts: true
  }, {
    id: 'reading',
    name: 'Reading',
    icon: '📚',
    unlocksPosts: false
  }, {
    id: 'painting',
    name: 'Painting',
    icon: '🎨',
    unlocksPosts: false
  }, {
    id: 'yoga',
    name: 'Yoga',
    icon: '🧘‍♀️',
    unlocksPosts: true
  }];
  const handleContinue = () => {
    if (selectedHobby) {
      onNext();
    }
  };
  return <div className="space-y-6" data-id="element-22204">
      <div className="flex items-center mb-6" data-id="element-22205">
        <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-22206">
          <ChevronLeft size={20} className="text-gray-500" data-id="element-22207" />
        </button>
        <div className="ml-4" data-id="element-22208">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-22209">
            Pick a Hobby
          </h2>
          <p className="text-gray-600 dark:text-gray-400" data-id="element-22210">
            What does your Angel enjoy in her free time?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-id="element-22211">
        {hobbies.map(hobby => <div key={hobby.id} onClick={() => onSelect(hobby.id)} className={`p-3 rounded-lg border cursor-pointer transition-all text-center relative ${selectedHobby === hobby.id ? 'border-pink-500 bg-pink-50 dark:bg-pink-900/20 shadow-md' : 'border-gray-200 dark:border-gray-700 hover:border-pink-300 dark:hover:border-pink-700 hover:shadow-sm'}`} data-id="element-22212">
            <div className="text-2xl mb-2" data-id="element-22213">{hobby.icon}</div>
            <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-22214">
              {hobby.name}
            </div>
            {hobby.unlocksPosts && <div className="absolute top-1 right-1 text-yellow-500" data-id="element-22215">
                <Star size={14} fill="currentColor" data-id="element-22216" />
              </div>}
          </div>)}
      </div>
      <div className="pt-6" data-id="element-22217">
        <div className="text-xs text-gray-500 dark:text-gray-400 mb-2 flex items-center" data-id="element-22218">
          <span className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 dark:bg-gray-700 rounded-full mr-2 text-xs" data-id="element-22219">
            ?
          </span>
          Your Angel will reference this hobby in chats and feed posts
        </div>
        <div className="text-xs text-yellow-500 dark:text-yellow-400 mb-4 flex items-center" data-id="element-22220">
          <Star size={14} fill="currentColor" className="mr-1" data-id="element-22221" />
          Hobbies with stars unlock exclusive posts
        </div>
        <button onClick={handleContinue} disabled={!selectedHobby} className={`w-full py-3 rounded-lg font-medium text-white ${!selectedHobby ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all'}`} data-id="element-22222">
          Next: Appearance & Style
        </button>
      </div>
    </div>;
};